require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./pevc-career-talk-session-1.json") })
        }
      }, "path---pevc-career-talk-session-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---pevc-career-talk-session-1!./.cache/json/pevc-career-talk-session-1.json
// module id = 1170
// module chunks = 231608221292675